import { NoteCell } from '#/shared/ui/table-cells'
import { useShipmentNotes } from '../lib/use-shipment-notes'

interface ShipmentNoteCellProps {
  shipmentId: string
  count?: number
}

export function ShipmentNoteCell({ shipmentId, count }: ShipmentNoteCellProps) {
  const { notes, isLoading, isSaving, isEditing, setEditing, arm, addNote } =
    useShipmentNotes(shipmentId, count)

  return (
    <div onMouseEnter={arm}>
      <NoteCell
        count={count}
        notes={notes}
        isLoading={isLoading}
        editing={isEditing}
        onEditingChange={setEditing}
        onAddNote={addNote}
        isSaving={isSaving}
      />
    </div>
  )
}
